/**
 * Allow citation format radio toggles to be fully collapsed.
 *
 * The citation block uses hidden radio inputs with Tailwind `checked:`/`not-checked:`
 * variants to show/hide panels. Native radio behavior prevents deselecting a checked
 * radio, so once a format is expanded one is always open. This script intercepts label
 * clicks and unchecks the radio when it is already active, collapsing the panel.
 */

window.addEventListener('DOMContentLoaded', () => {
  const citationRadios = document.querySelectorAll<HTMLInputElement>(
    'input[type="radio"][name="nav-tabs"]',
  );

  if (!citationRadios.length) return;

  citationRadios.forEach((radio) => {
    const label = document.querySelector<HTMLLabelElement>(`label[for="${radio.id}"]`);
    if (!label) return;

    label.addEventListener('click', (e) => {
      if (radio.checked) {
        e.preventDefault();
        radio.checked = false;
      }
    });
  });
});
